module.exports = __webpack_public_path__ + "img/en.ef454431.png";